import type { HealthcareUtilizationAnswer } from '~/generated/api-clients-generated'
import { ProfileStore } from '~/stores/profile'

export class HealthcareUtilizationSurveyVModel {
  static use(questionId: string) {
    const profile = ProfileStore.use()

    return computed({
      get() {
        const answer: HealthcareUtilizationAnswer =
          profile.needsAssessment!.healthcareUtilization?.find(
            (x) => x.questionId === questionId
          ) ?? { questionId: questionId, answer: null }
        return answer.answer ?? null
      },
      set: function (val: string | null) {
        profile.needsAssessment!.healthcareUtilization =
          profile.needsAssessment?.healthcareUtilization?.filter(
            (item) => item.questionId !== questionId
          )

        if (!_isNil(val)) {
          let newAnswer = { questionId: questionId, answer: val }
          profile.needsAssessment!.healthcareUtilization!.push(newAnswer)
        }
      }
    })
  }
}
